import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalConfig {
  heading: string;
  description: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  modalId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private readonly modalConfigSubject = new BehaviorSubject<ModalConfig | null>(null);
  private readonly isVisibleSubject = new BehaviorSubject<boolean>(false);
  private readonly primaryClickSubject = new BehaviorSubject<string>('');
  private readonly secondaryClickSubject = new BehaviorSubject<string>('');

  modalConfig$ = this.modalConfigSubject.asObservable();
  isVisible$ = this.isVisibleSubject.asObservable();
  primaryClick$ = this.primaryClickSubject.asObservable();
  secondaryClick$ = this.secondaryClickSubject.asObservable();

  show({
        heading,
        description,
        primaryButtonText,
        secondaryButtonText,
        modalId
    }: {
        heading: string;
        description: string;
        primaryButtonText: string;
        secondaryButtonText: string;
        modalId: string;
    }) {
    this.modalConfigSubject.next({heading, description, primaryButtonText, secondaryButtonText, modalId});
    this.isVisibleSubject.next(true);
  }

  hide(): void {
    this.modalConfigSubject.next(null);
    this.isVisibleSubject.next(false);
  }

  getModalConfig(): Observable<ModalConfig | null> {
    return this.modalConfig$;
  }

  getIsVisible(): Observable<boolean> {
    return this.isVisible$;
  }

  emitPrimaryClick(modalId : string): void {
    this.primaryClickSubject.next(modalId);
  }

  emitSecondaryClick(modalId): void {
    this.secondaryClickSubject.next(modalId);
  }
}